import * as React from 'react';
import FilterTag from '../TableFilter/FilterTag';
import { SvgImage } from '../SvgImage';
import { getAssetPath } from '../../util/images';
import {
  CreateSceneCancelButton,
  CreateSceneConfirmButton,
  CreateSceneFilterTagsWrapper,
  CreateSceneModalContent,
  CreateSceneModalFooter,
  CreateSceneModalHeader,
  CreateSceneModalWrapper,
  CreateSceneNameField,
  CreateSceneNameTextField,
  CreateSceneNameTextFieldSelect,
  CreateScenePrevStepsIcon,
  CreateSceneSecondaryText,
  CreateSceneStepsContainer,
  StyledCreateSceneModal,
  ModalHeaderText,
  CreateSceneModalParagraph,
  CreateSceneModalStep,
} from './CreateSceneModalComponents';
import {ButtonColorType} from "../Button";

const CreateSceneModal = props => {
  const { onSceneChange, rooms, onModalCancel } = props;
  // eslint-disable-next-line react/destructuring-assignment
  const [sceneInEdit, setSceneInEdit] = React.useState(props.sceneInEdit);
  const [sceneName, setSceneName] = React.useState(null);
  const [roomType, setRoomType] = React.useState(null);
  const [selectedRooms, setSelectedRooms] = React.useState(null);
  const [step, setStep] = React.useState(1);
  const [roomsTypes, setRoomsTypes] = React.useState([]);

  const refreshRoomTypes = () => {
    const types = [
      ...rooms
        .filter(
          room =>
            !selectedRooms ||
            !selectedRooms.some(selectedRoom => selectedRoom.value === room.id)
        )
        .map(room => ({ value: room.id, label: room.name }))
    ];

    setRoomsTypes(types);
  };

  React.useEffect(() => {
    refreshRoomTypes();
  }, [rooms, selectedRooms]);
  React.useEffect(() => {
    onSceneChange(sceneInEdit);
  }, [sceneInEdit]);

  return (
    <CreateSceneModalWrapper>
      <StyledCreateSceneModal>
        <ModalHeaderText>Add new</ModalHeaderText>
        <CreateSceneModalContent>
          <CreateSceneModalHeader>Scene</CreateSceneModalHeader>
          <CreateSceneModalParagraph>
            Simple static group of devices & their parameters, turned on
            user&apos;s command
          </CreateSceneModalParagraph>
          {step === 1 && (
            <CreateSceneNameField>
              <CreateSceneNameTextField
                placeholder="Name your scene (max. 60 characters)"
                value={sceneName}
                onChange={name => setSceneName(name)}
                testId="add_scene_name"
              />
              <CreateSceneConfirmButton
                type="button"
                text="Okay"
                disabled={!sceneName || sceneName.length > 60}
                onClick={() => {
                  setStep(2);
                  setSceneInEdit({ ...sceneInEdit, name: sceneName });
                }}
                testId="add_scene_button"
                colorType={ButtonColorType.WHITE}
              />
            </CreateSceneNameField>
          )}

          {step === 2 && (
            <div>
              <CreateSceneNameField>
                <CreateSceneNameTextFieldSelect
                  value={roomType}
                  options={roomsTypes}
                  placeholder="Select rooms"
                  onChange={selectedRoom => {
                    setRoomType(selectedRoom);
                  }}
                  testId="add_scene_name_input"
                />
                <CreateSceneConfirmButton
                  type="button"
                  text="Okay"
                  disabled={!roomType}
                  onClick={() => {
                    setSelectedRooms([...(selectedRooms || []), roomType]);
                    setRoomType(null);
                  }}
                  testId="add_scene_name_confirm_button"
                  colorType={ButtonColorType.WHITE}
                />
              </CreateSceneNameField>
              <CreateSceneFilterTagsWrapper>
                {selectedRooms &&
                  selectedRooms.map(selectedRoom => (
                    <FilterTag
                      key={`filter-tag-${selectedRoom.value}`}
                      filterKey={selectedRoom.value}
                      value={selectedRoom.label}
                      onRemoveTag={removedRoomId =>
                        setSelectedRooms([
                          ...selectedRooms.filter(
                            room => room.value !== removedRoomId
                          )
                        ])
                      }
                    />
                  ))}
              </CreateSceneFilterTagsWrapper>
            </div>
          )}

          <CreateSceneSecondaryText>
            Make sure it will easy to recognise e.g. Micheal&apos;s chill lights
            (max. 60 characters)
          </CreateSceneSecondaryText>
          <CreateSceneModalFooter>
            <CreateSceneCancelButton
              type="button"
              onClick={() => onModalCancel()}
              data-testid="add_scene_cancel_button"
            >
              Cancel
            </CreateSceneCancelButton>

            <CreateSceneStepsContainer>
              {step === 2 && (
                <CreateScenePrevStepsIcon
                  type="button"
                  onClick={() => setStep(1)}
                  data-testId="add_scene_prev_button"
                >
                  <SvgImage
                    inAssetsPath={getAssetPath('icons/table-arrow-down.svg')}
                  />
                </CreateScenePrevStepsIcon>
              )}
              <CreateSceneModalStep>{step} of 2</CreateSceneModalStep>
              {sceneInEdit.name && (
                <CreateSceneConfirmButton
                  type="button"
                  text="Go to creator"
                  onClick={() => {
                    setSceneInEdit({
                      ...sceneInEdit,
                      name: sceneName,
                      roomIds: selectedRooms
                        ? selectedRooms.map(({ value }) => value)
                        : []
                    });
                  }}
                  testId="add_scene_creator_button"
                  colorType={ButtonColorType.WHITE}
                />
              )}
            </CreateSceneStepsContainer>
          </CreateSceneModalFooter>
        </CreateSceneModalContent>
      </StyledCreateSceneModal>
    </CreateSceneModalWrapper>
  );
};

export default CreateSceneModal;
